import React, {useState, useEffect, useContext, useRef} from 'react';
import { useHistory } from "react-router-dom";
import { LoadingDots } from "partials/progress-loader";
import SessionContext from "SessionContext";
import {Button, Alert } from "reactstrap";

const BASE_URL = window.location.origin;


export default function ExternalDestinationForm() {
  const history = useHistory();
  const session = useContext(SessionContext);
  const [loadingFrame, setLoadingFrame] = useState(false);
  const [failedToLoad, setFailedToLoad] = useState(false);
  const [destinationsList, setDestinationsList] = useState(null);
  const [destinationSelected, setDestinationSelected] = useState("");
  const [selectedLabel, setSelectedLabel] = useState("");
  const [calledOnce, setCalledOnce] = useState(false);

  const handleSelectDestination = (_item) => {
    let _value = _item.value;
    let _label = _item.label;
    setFailedToLoad(false);
    if(_item === "none") {
      setDestinationSelected("");
      setSelectedLabel("");
      return;
    }
    setDestinationSelected(_value);
    setSelectedLabel(_label);
  };

  const createConnectLink = (e) => {
    e.preventDefault();
    setLoadingFrame(true);
    setSelectedLabel("");
    let params = {
      "type": destinationSelected,
      "redirect_uri": `${BASE_URL}/external-destination-edit-form`,
    }

    session.command("census/destination-connect-link", params, {}, { defaultErrorHandling: false }).then((data) => {
      setLoadingFrame(false);
      window.location.href = `${data.uri}`;
    })
    .catch((err) => {
      console.error('No connect URL returned', err);
      setTimeout(() => {
        setLoadingFrame(false);
        setFailedToLoad(true);
      }, 300);
    })
  };

  useEffect(() => {
    const getList = () => {
      session.query("census/list-destination-types", { }).then((data) => {
          let _options = data.map(item => ({
            label: item.label,
            value: item.service_name,
          }));
          setDestinationsList(_options)
      })
      .catch(err => console.error('Fetch error:', err));
    }
    
    if(!calledOnce) {
      setCalledOnce(true);
      getList();
    } 
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  function onClickBack(ev) {
    ev.stopPropagation();
    history.push("/external-destinations");
  }
  
  return (
      <div className="page admin-page">
        <div className="list-header sticky-page-header">
          <button className="new-button" onClick={onClickBack}>
            <i className="bi bi-chevron-left"></i> External Destinations
          </button>
          <h1>External Destination Form</h1>
          <i className="spacer" />
        </div>
        <div className="m-5 text-center">

        {destinationsList && (
          <div className="destination-dropdown-wrapper">
            <DestinationDropdown
              destinationsList={destinationsList}
              destinationSelected={destinationSelected}
              onSelect={handleSelectDestination}
              loadingFrame={loadingFrame}
            />
          </div>
        )}

        {loadingFrame && (
          <div className="destination-loading-styles"><LoadingDots message="Connecting..." /></div>
        )}
          
        {
          (selectedLabel && !loadingFrame && !failedToLoad) && (
          <div className="destination-link-wrapper">
            <div className="card">
              <div className="card-body">
                <div>Link your <b>{selectedLabel}</b> account through Census</div>
                <Alert color="warning" className="d-flex mt-3">
                  <i className="bi bi-lightbulb"></i> 
                  Important: You will be redirected to an external page to complete the setup. After completing the steps there, you'll return to AudienceMaker automatically.
                </Alert>
                <Button
                  type="button"
                  onClick={createConnectLink} 
                  className="new-button mt-3"
                  disabled={loadingFrame}>
                    Open Setup Page
                </Button>
              </div>
            </div>
          </div>
          )
        }
        </div>
      </div>
  )
}


/*
 * dropdown that allows to search inside the list 
 */
function DestinationDropdown({ destinationsList, destinationSelected, onSelect, loadingFrame }) {
  const [isOpen, setIsOpen] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const dropdownRef = useRef(null);

  const filteredDestinations = destinationsList.filter(option =>
    option.label.toLowerCase().includes(searchTerm.toLowerCase())
  );

  // close dropdown when clicking outside
  useEffect(() => {
    function handleClickOutside(e) {
      if (dropdownRef.current && !dropdownRef.current.contains(e.target)) {
        setIsOpen(false);
      }
    }
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  return (
    <div ref={dropdownRef} className="destination-dropdown">
      <div
        onClick={() => !loadingFrame && setIsOpen(!isOpen)}
        className="destination-dropdown-label"
      >
        {destinationSelected
          ? destinationsList.find(d => d.value === destinationSelected)?.label
          : "Select a Destination"}
      </div>

      {isOpen && (
        <div className="dropdown-body">
          <input
            type="text"
            placeholder="Type to search..."
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            disabled={loadingFrame}
          />
          <div className="dropdown-options-wrapper">
            <div
              style={{ padding: "8px", cursor: "pointer" }}
              onClick={() => {
                onSelect("none");
                setIsOpen(false);
                setSearchTerm("");
              }}
            >
              None
            </div>

            {filteredDestinations.map(option => (
              <div
                key={option.value}
                className={option.value === destinationSelected ? "option selected-background" : "option no-back"}
                onClick={() => {
                  onSelect(option);
                  setIsOpen(false);
                  setSearchTerm("");
                }}
              >
                {option.label}
              </div>
            ))}

            {filteredDestinations.length === 0 && (
              <div className="item-label">No results</div>
            )}
          </div>
        </div>
      )}
    </div>
  );
}

